'use client';
import { ComponentType } from 'react';
import { PlaceholderConfig } from '@spa/lib/react/context/PlaceholderContext';
import { Props } from './accordion.component';
import dynamic from 'next/dynamic';

const DynamicAccordionComponent: ComponentType<Props> = dynamic(
  () => import('./accordion.component')
);

export default DynamicAccordionComponent;

export function calculateAccordionPlaceholderConfig(): PlaceholderConfig {
  const heightSinceWidth = [
    { sinceWidth: 0, height: 162 },
    { sinceWidth: 768, height: 192 }
  ];

  return {
    heightSinceWidth
  };
}
